import * as PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import supportPatient from '../../assets/avatar-support-patient.png';
import Button from '../Button';
import './welcomeScreen.css';

const Support = ({ onClickSupport }) => {
  const { t } = useTranslation('components');

  return (
    <div className="mb-8 xl:pb-8">
      <h2 className="font-semibold text-xl mb-2 text-slate-500">
        {t('physician_welcome_screen.support.title', {
          allowHtml: true,
        })}
      </h2>
      <div className="flex w-full justify-center">
        <div className="flex">
          <img src={supportPatient} alt="support" className="h-12 w-12 rounded-full mr-8" />
          <div className="border flex flex-col items-center relative bg-white">
            <div className="span italic py-4 px-8">
              {t('physician_welcome_screen.support.message')}
            </div>
            <Button
              className="mb-4"
              size="sm"
              onClick={event => {
                event.preventDefault();
                onClickSupport(event);
              }}
            >
              {t('physician_welcome_screen.support.link')}
            </Button>
            <div className="welcomeScreenTriangle" />
          </div>
        </div>
      </div>
    </div>
  );
};

Support.defaultProps = {
  onClickSupport: () => {},
};

Support.propTypes = {
  onClickSupport: PropTypes.func,
};

export default Support;
